import Section from "../Section";

export default class Cart extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    Array.prototype.forEach.call(
      this.element.querySelectorAll('.js-qty__adjust'),
      (el) => el.addEventListener('click', this.changeQuantity),
    );
  }

  changeQuantity = (e) => {
    e.preventDefault();
    const input = e.currentTarget.closest('.js-qty').querySelector('input');
    if (e.currentTarget.classList.contains('js-qty__adjust--minus')) {
      input.value = Math.max(1, parseInt(input.value, 10) - 1);
    } else {
      input.value = parseInt(input.value, 10) + 1;
    }
  }
}
